module.exports = __webpack_public_path__ + "img/survival_plot.d894897b.svg";